import styled from '@emotion/styled';

interface InputTextProps {
	type?: string;
}

export const Container = styled.div`
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 6rem;
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const Content = styled.pre`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	white-space: pre-wrap;
	word-break: break-word;
`;
export const PrimaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const PrimaryContentTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%; /* 26px */
	letter-spacing: -0.6px;
`;
export const SecondaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
export const SecondaryContent = styled.ol<InputTextProps>`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem;
	background-color: #f8f9fa;
	color: #495057;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%; /* 26px */
	letter-spacing: -0.6px;
	list-style: none; /* 기본 스타일 초기화 */
	counter-reset: list-counter; /* 초기화 */
	> li {
		counter-increment: list-counter; /* 기본 번호 */
		position: relative;
		padding-left: 1.5rem; /* 번호를 위한 공간 확보 */
	}
	> li::before {
		content: counter(list-counter) '. ';
		position: absolute;
		left: 0;
		color: #495057;
	}
	ol[type='a'] {
		list-style-type: none; /* 기본 숫자 스타일 초기화 */
		padding-left: 1.5rem;
		counter-reset: list-counter; /* 알파벳 번호 초기화 */
	}
	ol[type='a'] > li {
		counter-increment: list-counter; /* 각 li마다 카운트 증가 */
	}
	ol[type='a'] > li::before {
		content: counter(list-counter, lower-alpha) '. '; /* 소문자 알파벳 번호 */
	}
`;
export const TertiaryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const TertiaryContentTitle = styled.h5`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%; /* 26px */
	letter-spacing: -0.6px;
`;
export const TertiaryContent = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
